import type { Cohort } from '@efdigital/ll-addon-data';
import {
  addClass,
  hasClass,
  removeClass,
} from '@efdigital/ll-addon-ui/utils/css-class-helpers';
import { EditRecord } from '@efdigital/ll-admin-v2/components/edit-record.gts';
import { type EditRecordSignature } from '@efdigital/ll-admin-v2/components/edit-record-base.gts';
import { on } from '@ember/modifier';
import Component from '@glimmer/component';

export class EditCohortVisibility extends Component<
  EditRecordSignature<Cohort>
> {
  get showAnnouncements(): boolean {
    return !hasClass(this.args.item.css ?? '', 'hide-announcements');
  }

  toggleAnnouncements = (event: Event) => {
    const target = event.target as HTMLInputElement;
    const css = this.args.item.css ?? '';
    this.args.item.css = target.checked
      ? removeClass(css, 'hide-announcements')
      : addClass(css, 'hide-announcements');
  };

  get showDiscussions(): boolean {
    return !hasClass(this.args.item.css ?? '', 'hide-discussions');
  }

  toggleDiscussions = (event: Event) => {
    const target = event.target as HTMLInputElement;
    const css = this.args.item.css ?? '';
    this.args.item.css = target.checked
      ? removeClass(css, 'hide-discussions')
      : addClass(css, 'hide-discussions');
  };

  <template>
    <EditRecord
      @editLabel="Edit Visibility"
      @item={{@item}}
      @context={{@context}}
      @maxDepth={{1}}
      ...attributes
    >
      <:form as |uniqueId isDisabled|>
        <fieldset disabled={{isDisabled}} class="mb-4">
          <legend class="gud-eyebrow">Visibility</legend>
          <p class="text-muted small">
            Control which features are visible to participants in this cohort.
          </p>

          <div class="form-check mb-2">
            <input
              type="checkbox"
              class="form-check-input"
              id="{{uniqueId}}-show-announcements"
              checked={{this.showAnnouncements}}
              {{on "change" this.toggleAnnouncements}}
            />
            <label
              class="form-check-label"
              for="{{uniqueId}}-show-announcements"
            >
              Show Announcements
            </label>
            <div class="form-text">
              Display the announcements section to participants.
            </div>
          </div>

          <div class="form-check">
            <input
              type="checkbox"
              class="form-check-input"
              id="{{uniqueId}}-show-discussions"
              checked={{this.showDiscussions}}
              {{on "change" this.toggleDiscussions}}
            />
            <label class="form-check-label" for="{{uniqueId}}-show-discussions">
              Show Discussions
            </label>
            <div class="form-text">
              Enable discussion forums for this cohort.
            </div>
          </div>
        </fieldset>
      </:form>
    </EditRecord>
  </template>
}
